import { IGuardPermissions } from '@portal/shared/auth/authorization/src/lib/interfaces/guard-permissions.interface';

export function createPermissions<T extends Record<string, IGuardPermissions>>(
  props: T,
): Record<keyof T, IGuardPermissions> {
  return props;
}
